import React from "react";
import Header from "../components/Header";
import {useSeo} from '../hooks/useMetadata';
import "../assets/css/About.css"
import aboutImg from "../images/about.png";
import GoftinoWidget from "../components/GoftinoWidget";

export default function About() {
    useSeo(
        'استودیو بازیسازی مدریک: درباره ما',
        'به استودیوی بازیسازی مدریک خوش آمدید. درباره ما بیشتر بدانید.',
        {keywords: 'medrick, game studio, mobile game'}
    );
    return (
        <>
            <Header title=" بی‌خیالش ! بازی کن"/>
            <GoftinoWidget />
            <section className="root">
                <div className="wrap">
                    <div className="hero">
                        <div className="figure">
                            <img
                                className="img"
                                src={aboutImg}
                                alt="game rights"
                            />
                        </div>
                        <div>
                            <div>
                                <h1 className="title">
                                    درباره <span>مدریک گیمز</span>
                                </h1>
                                <p className="p">
                                    <b>شرکت بازی‌گستران دریک</b> که با اسم مدریک معروف است، ‌با هدف توسعه و انتشار بازی‌های موبایلی باکیفیت، خلاق
                                    و
                                    الهام‌گرفته از فرهنگ ایرانی، در سال ۱۳۹۱ فعالیت خود را آغاز کرد. از همان ابتدا،
                                    مأموریت
                                    ما خلق تجربه‌هایی بود که فراتر از سرگرمی صرف باشند — تجربه‌هایی که احساسات، تخیل و
                                    ذهن
                                    بازیکنان را درگیر کنند و پلی میان فناوری، هنر و روایت انسانی بسازند. در مدریک، ما
                                    بازی
                                    را نه فقط به عنوان یک محصول، بلکه به عنوان یک عنصر سرگرمی می‌بینیم. رسانه‌ای که
                                    می‌تواند
                                    الهام‌بخش باشد، ارتباط بسازد و دنیای تازه‌ای را پیش روی مخاطب بگشاید. به همین دلیل،
                                    تمرکز ما همیشه بر کیفیت طراحی، نوآوری در روندبازی و روایت، و شناخت عمیق از مخاطب
                                    بوده
                                    است.
                                </p>
                                <p className="p">
                                    در طول بیش از یک دهه فعالیت، مدریک توانسته است با اتکا به تیمی پویا، متخصص و عاشق
                                    بازی،
                                    مجموعه‌ای از آثار موفق را تولید و منتشر کند که میلیون‌ها بازیکن در ایران و کشورهای
                                    مختلف
                                    از آن‌ها لذت برده‌اند. ما با تمرکز بر روندهای جهانی صنعت بازی، به دنبال خلق
                                    تجربه‌هایی
                                    هستیم که هم با سلیقه بین‌المللی هم‌خوانی داشته باشند و هم ریشه در هویت فرهنگی ما
                                    داشته
                                    باشند. در مسیر رشد، همکاری با استعدادهای تازه و تیم‌های خلاق یکی از ارزش‌های بنیادین
                                    ماست. ما باور داریم آینده‌ی صنعت بازی ایران با همکاری، آموزش و فرصت‌سازی برای نسل
                                    جدید
                                    شکل خواهد گرفت. به همین دلیل، مدریک همواره به‌عنوان پلی میان توسعه‌دهندگان، هنرمندان
                                    و
                                    ناشران عمل کرده و سعی دارد زیرساختی پایدار برای رشد این صنعت فراهم آورد. ما به
                                    آینده‌ای
                                    باور داریم که در آن بازی‌ها بیش از هر زمان دیگری نقش‌آفرین خواهند بود — در آموزش،
                                    فرهنگ،
                                    تعاملات اجتماعی و حتی تصمیم‌سازی‌های بزرگ. و مدریک در قلب این مسیر ایستاده است؛ جایی
                                    که
                                    رویاها به بازی تبدیل می‌شوند.
                                </p>
                            </div>
                            <div>
                                <h1 className="title">
                                    ارزش‌ها و باورهای ما
                                </h1>
                                <p className="p">
                                    در مدریک، فرهنگ کاری ما بر پایه‌ی مجموعه‌ای از ارزش‌های پایدار شکل گرفته است که در
                                    تمام
                                    فعالیت‌ها و تصمیم‌گیری‌های ما حضور دارند:
                                </p>
                                <p className="title-style">
                                    🎮 خلاقیت و نوآوری:
                                </p>
                                <p className="p">
                                    ما به دنبال ایده‌های تازه‌ای هستیم که مرزهای تجربه‌ی بازی را گسترش دهند و مخاطب را
                                    شگفت‌زده کنند.
                                </p>
                                <p className="title-style">
                                    🌍 کیفیت و اصالت:
                                </p>
                                <p className="p">
                                    ما باور داریم هر جزئیات — از طراحی بصری تا صدای بازی — بخشی از تجربه‌ای است که باید
                                    به
                                    بهترین شکل ممکن ارائه شود.
                                </p>
                                <p className="title-style">
                                    🤝 تعاون و یادگیری:
                                </p>
                                <p className="p">
                                    ما محیطی پویا و یادگیرنده می‌سازیم که در آن افراد بتوانند رشد کنند، از هم بیاموزند و
                                    با
                                    همکاری جمعی به نتایج بزرگ‌تری برسند.
                                </p>
                                <p className="title-style">
                                    🚀 پایداری و رشد مستمر:
                                </p>
                                <p className="p">
                                    مدریک به آینده می‌اندیشد؛ به ساختن زیرساختی پایدار برای توسعه‌ی بازی‌سازی در ایران و
                                    حضور پرقدرت در بازار جهانی.
                                </p>
                            </div>
                            <div>
                                <h1 className="title">
                                    چشم‌انداز مدریک
                                </h1>
                                <p className="p">
                                    چشم‌انداز ما، تبدیل شدن به پیشروترین پلتفرم توسعه و انتشار بازی‌های موبایلی در
                                    خاورمیانه است — جایی که استعدادهای ایرانی و منطقه‌ای بتوانند بازی‌هایی خلق کنند که
                                    در سطح جهانی بدرخشند.
                                </p>
                                <p className="p">
                                    ما می‌خواهیم نقشی فعال در شکل‌گیری آینده‌ی صنعت سرگرمی دیجیتال ایفا کنیم؛ آینده‌ای
                                    که در آن بازی، نه فقط ابزاری برای سرگرمی، بلکه بستری برای یادگیری، تعامل، هویت و
                                    تحول اجتماعی خواهد بود.
                                </p>
                                <p className="p">
                                    در مدریک، ما در مسیر این آینده حرکت می‌کنیم؛ گام‌به‌گام، با باور، خلاقیت و اشتیاقی
                                    بی‌پایان.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="stats">
                        {[
                            {n: "250+", t: "امتیاز فعال"},
                            {n: "70+", t: "ناشر و توسعه‌دهنده"},
                            {n: "1M+", t: "بازیکن تحت لایسنس"},
                            {n: "24/7", t: "پشتیبانی معاملات"},
                        ].map((x) => (
                            <div key={x.t} className="stats">
                                <div className="num">{x.n}</div>
                                <div className="cap">{x.t}</div>
                            </div>
                        ))}
                    </div>

                    <div className="cards">
                        {[
                            {
                                h: "برای فروشندگان امتیاز",
                                b: "ارزیابی منصفانه، نمایش به خریداران واقعی و پشتیبانی قراردادی تا عقد قرارداد."
                            },
                            {
                                h: "برای خریداران/ناشران",
                                b: "کاتالوگ به‌روز امتیازها، فیلترهای تخصصی و تطبیق سریع با نیاز بازار."
                            },
                            {
                                h: "امنیت و شفافیت",
                                b: "قراردادهای استاندارد، فرایند ضدتقلب و رهگیری لحظه‌ای وضعیت معامله."
                            },
                            {h: "شبکه‌ی صنعت گیم", b: "ارتباط مستقیم با ناشران معتبر و توسعه‌دهندگان حرفه‌ای."},
                        ].map((c) => (
                            <div key={c.h} className="card">
                                <h3>{c.h}</h3>
                                <p>{c.b}</p>
                            </div>
                        ))}
                    </div>

                    <div className="cta">
                        <a href="/contact" className={"btn primary"}>تماس با ما</a>
                    </div>
                </div>
            </section>
        </>
    );
}
